<template>
  <b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="label" :no-close-on-esc=true v-model="show" 
    :dialog-class="(!isExpanded ? ' ' : 'b-dialog-large ') + modalClass"
    :ok-title="okTitle"
    ok-variant="success" 
    :cancel-title="cancelTitle" 
    @ok="saveAction"
    @hidden="onHidden"
    v-bind="$attrs"
    >
    <template #modal-header>
      <div class="w-100">
        <b-row>
          <b-col cols="12" md="9" :class="'d-flex pl-sm-0 pl-md-3' + showLeftIcon ? ' modal-title-icon' : ''">
            <slot name="modal-header-left-button">
              <span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$bvModal.hide('modal-input')"><b-icon-arrow-left /></b-button>
              </span>
            </slot>
            <span v-if="showLeftIcon" class="icon-add">
              <img :src="publicPath + '/img/' + leftIcon" class="img-icon-add" />
            </span>
            <h5 class="modal-title"><app-long-text :maxLength="15" :mdMaxLength="50" :text="label" /></h5>
          </b-col>
          <b-col cols="3">
            <span class="float-right mr-1 d-md-block d-sm-none">
                <span v-for="(item, index) in editor" :key="item">
                  <b-avatar :variant="getVariant(index)" :id="'editor-avatar-' + index " style="margin-left: -3px" :text="item | short_hand"></b-avatar>
                  <b-tooltip :target="'editor-avatar-' + index ">{{ item }}</b-tooltip>
                </span>
                <b-button size="sm" v-if="!isExpanded" class="expand btn-link border-0 mt-1" @click="isExpanded = true">
                  <b-icon-arrows-angle-expand />
                </b-button>
                <b-button size="sm" v-else class="expand btn-link border-0 mt-1" @click="isExpanded = false">
                  <b-icon-arrows-angle-contract />
                </b-button>
                <b-button size="sm" class="mt-1 ml-1 btn-link btn-popup-close" @click="$bvModal.hide('modal-input')"><b-icon-x /></b-button>
            </span>
          </b-col>
        </b-row>
      </div>
    </template>
    <template #modal-footer="{ ok, cancel }">
      <slot name="modal-action-button">
        <slot name="modal-left-button"></slot>
        <b-button size="sm" class="btn-outline-success float-right" @click="cancel()">
          {{ cancelTitle }}
        </b-button>
        <b-overlay
            :show="isBusy"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="float-right "
            >
        <b-button size="sm" class="btn-fill-success float-right" @click="ok()">
          <b-icon-plus-square class="mr-1"></b-icon-plus-square>
          {{ okTitle }}
        </b-button>
        </b-overlay>
      </slot>
		</template>
    <slot/>
  </b-modal>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PopupWrap',
  data() {
    return {
      show : true,
      editor: [],
      isExpanded: false,
    }
  },
  filters: {
   short_hand (name) {
    let words = name.split(" ")
    let short_hand = words[0][0] + (words[words.length-1] != undefined && words[words.length-1] != null && words[words.length-1] != '' ? words[words.length-1][0] : "")
    return short_hand;
   }
  },
  props: {
    isLarge: {
      default: true
    },
    centered: {
      default: true,
      type: Boolean,
    },
    focusElement: {
      default: null,
      type: Object,
    },
    label: {
      required: true,
      type: String,
    },
    entityName: {
      type: String,
    },
    documentId: {
      type: String,
    },
    okTitle: {
      default: 'Simpan',
      type: String,
    },
    cancelTitle: {
      default: 'Batal',
      type: String,
    },
    isBusy: {
      default: false,
      type: Boolean,
    },
    showLeftIcon: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      default: 'add-icon.png',
      type: String,
    },
    modalClass: {
      type: String,
    },
  },
  mounted() {
    const close = (e) => {
      const ESC = 27;
      if (e.keyCode !== ESC) return;
      this.$emit('close');
    };

    /*document.addEventListener('keyup', close);
    this.$on('hook:destroyed', () => {
      document.removeEventListener('keyup', close);
    });*/

    this.activate();
    this.$on('hook:destroyed', () => {
      this.deactivate();
    });
    
    /*this.$nextTick(() => {
      this.checkEditor();
    });*/
  },
  methods: {
    activate() {
      this.previousActiveElement = document.activeElement;
      this.inert();
    },
    saveAction(modalEvent) {
      this.$emit("saveMethod", modalEvent);
    },
    onHidden() {
      this.$emit('hideMethod');
      this.$emit('close');
    },
    async deactivate() {
      await this.inert(false);
    },
    async inert(status = true) {
      await this.$nextTick();
      [...this.$root.$el.children].forEach((child) => {
        if (child === this.$el || child.contains(this.$el)) return;
        child.inert = status;
      });
    },
    getVariant(index) {
      let variant = ['warning', 'danger', 'info', 'primary', 'success'];
      if (index > (variant.length - 1)) {
        index = index % variant.length;
      }
      return variant[index];
    },
    async checkEditor() {
      if (this.documentId != null && this.documentId != undefined && this.documentId != 'null' && this.documentId != '') {
        this.$http.get(process.env.VUE_APP_API_URL + this.entityName + '/currenteditor/' + this.documentId)
        .then(response => {
          if (response != null) {
            this.editor = [];
              if (response.data.length > 0) {
                response.data.forEach(item => {
                  if (this.editor.indexOf(item) < 0) {
                    this.editor.push(item);
                  }
                });
              }
          }
        }).catch(error => {});
      }
    },
  },
  watch : {
    documentId(newValue, oldValue) {
      if (newValue != oldValue)
          this.checkEditor();
    }
  }
};
</script>

<style>
.modal-dialog {
    max-width: 1008px !important;
    height: 100vh;
    display: flex;
}
.modal-body {
  background: #EEF0F8 !important;
}

.b-dialog-small {
  max-width: 50% !important;
}

.b-dialog-large {
  max-width: 99% !important;
  max-height: 100% !important;
}

@media (max-width:768px) {
  .modal-dialog {
    max-width: 100% !important;
  } 

  .b-table-top-row {
    background: #f3f6f9 !important;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 100% !important;
  }

  .b-table-top-row {
    background: #f3f6f9 !important;
  }
}
</style>